export const stringToDate = (dateString: string | undefined) => {
    if (dateString) {
        const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;
        if (dateRegex.test(dateString)) {
            const newValueParts = dateString.trim().split('/');
            const day = Math.max(1, Math.min(31, Number.parseInt(newValueParts[0], 10)));
            const month = Math.max(1, Math.min(12, Number.parseInt(newValueParts[1], 10))) - 1;
            let year = Number.parseInt(newValueParts[2], 10);
            return new Date(year, month, day);
        }
    }
    return null;
}

export interface dateValidationResult {
    isValid: boolean;
    errorMessage: string;
    isFutureDate?: boolean;
    isPastDate?: boolean;
}

export const validateDate = (value: string | undefined, dateInPast = true): dateValidationResult => {
    console.log("Validate", value);
    if (value) {
        const date = stringToDate(value);
        // _handleDateChange(date, 'dateOfBirth');
        if (date) {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let dayString = day < 10 ? '0' + day.toString() : day.toString();
            let monthString = month < 10 ? '0' + month.toString() : month.toString();

            if (dayString + '/' + monthString + '/' + date.getFullYear() !== value) {
                return {isValid: false, errorMessage: 'Invalid date format', isFutureDate: false, isPastDate: false};
            }
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (dateInPast && date > today) {
                return {isValid: false, errorMessage: 'Future dates are not permitted', isFutureDate: true, isPastDate: false};
            } else if (!dateInPast && date < today){
                return {isValid: false, errorMessage: 'Past dates are not permitted', isFutureDate: false, isPastDate: true};
            }
        } else {
            return {
                isValid: false, errorMessage: 'Invalid date format', isFutureDate: false, isPastDate: false
            };
        }
    }
    return {isValid: true, errorMessage: '', isFutureDate: false, isPastDate: false};
}
